// extracted by mini-css-extract-plugin
export default {"noData":"myTable_noData__JpP-r"};